import { getCurrentInstance } from 'vue'
import { useRoute as _useRoute } from 'vue-router'

export const useNavigator = () =>
  getCurrentInstance()?.appContext.config.globalProperties.$navigator

export const useRoute = _useRoute
